<template>
  <rabbey-base-drawer
    title="Nueva Solicitud"
    size="60%"
    :drawer.sync="drawer"
    :before-close="handleClosed"
    :open="opening"
    :with-header="true"
    :wrapperClosable="false"
  >
    <el-row>
      <el-col>
        <el-form
          :rules="rules"
          ref="formName"
          size="mini"
          :label-position="position"
          label-width="100px"
          :model="objRules"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="Gerencia">
                <el-select
                  v-model="objRules.direccionsList.ID"
                  placeholder="Seleccion de dirección"
                  filterable
                  style="width: 100%"
                  @change="handleChangeDirections"
                  :disabled="selectionsDisable"
                >
                  <el-option
                    v-for="(direction, index) in objRules.direccionsList"
                    :key="index"
                    :value="direction.ID"
                    :label="direction.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Departamento"
                v-if="
                  objRules.direccionsList.ID === 41 ||
                  objRules.direccionsList.ID === 46 ||
                  objRules.direccionsList.ID === 28
                "
              >
                <el-select
                  v-model="objRules.departmentselected"
                  placeholder="Seleccion de departamento"
                  filterable
                  style="width: 100%"
                  @change="handleChangeDepartment"
                  :disabled="selectionsDisable"
                >
                  <el-option
                    v-for="(department, index) in departmentListfiltered"
                    :key="index"
                    :value="department.ID"
                    :label="department.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Tipo" prop="serviceTypeList.Id">
                <el-select
                  v-model="objRules.serviceTypeList.Id"
                  placeholder="Selección tipo de solicitud"
                  filterable
                  ref="serviceTypeFilter"
                  style="width: 100%"
                  @change="showHideInput"
                  :disabled="selectionsDisable"
                >
                  <el-option
                    v-for="(serv, index) in serviceTypeFiltered"
                    :key="index"
                    :value="serv.Id"
                    :label="serv.Description"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="objRules.direccionsList.ID == 42">
              <el-form-item label="Tipo">
                <el-select
                  v-model="ChangesDirectionsIT"
                  @change="getItems()"
                  :placeholder="'Desarrollo'"
                  size="mini"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, key) in DirectionsITList"
                    :key="key"
                    :label="item.Label"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item
            id="payDate"
            hidden
            label="Fecha Limite"
            style="font-weight: bold; width: 65%"
          >
            <el-date-picker
              type="date"
              placeholder="Fecha Limite"
              v-model="model.paymentDate"
              style="width: 50%"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Descripción" prop="descripcionRule">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="Descripción Aquí"
              v-model="objRules.descripcionRule"
            ></el-input>
          </el-form-item>

          <el-form-item label="Más Detalles">
            <quill-editor ref="myQuillEditor" v-model="comment" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- :on-success="handleUploadOnSuccess" -->
    <el-row>
      <el-col>
        <el-upload
          ref="uploadFile"
          class="upload-demo"
          :drag="true"
          accept="image/*,.pdf,.xlsx,.docx"
          action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
          :on-success="handleUploadOnSuccess"
          :on-exceed="handleExceed"
          :auto-upload="true"
          :multiple="true"
          :on-change="handleChange"
          :on-remove="handleRemove"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Arrastre los Archivos aquí
            <em>click aquí para Agregar archivos</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            Agregar Archivos que pesen menos de 500kb
          </div>
        </el-upload>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-button
          style="color: white"
          :disabled="disabledButton"
          type="primary"
          plain
          v-loading="loading"
          v-on:click="postServicesTypes"
          >Registrar</el-button
        >
        <el-button
          :disabled="disabledButton"
          type="danger"
          v-on:click="closeFormSupport"
          >Cancelar</el-button
        >
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
export default {
  name: "newRequestForm",
  props: {
    ResquestObject: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    quillEditor
  },
  data() {
    return {
      loading: false,
      fileName: "",
      dataToUpload: {
        id: 0
      },
      headers: {
        Authorization: `Bearer ${this.$store.state.auth.token}`
      },
      ChangesDirectionsIT: null,
      DirectionsITList: [
        { Id: 0, Label: "Nuevo Desarrollo" },
        { Id: 1, Label: "Solicitudes Internas" },
        { Id: 2, Label: "Solicitudes Externas" },
        { Id: 3, Label: "Infraestructura" },
        { Id: 4, Label: "Soporte Técnico" }
      ],
      fileListUploadFiles: [],
      IDRequest: 0,
      count: 0,
      fileList: [],
      filesUpload: 0,
      filesUploadDates: [],
      direccionID: 0,
      disabledButton: false,
      serviceRequestTypeSelectdID: 0,
      DirectionSelectedID: 0,
      productSelectedID: 0,
      fechaSolicitud: "",
      productList: [],
      departmentList: [],
      dirSelected: "",
      productSelected: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      selectionsDisable: false,
      hora: "00:00",
      position: "top",
      drawer: false,
      Supervisor: 0,
      descripcion: "",
      model: {
        ClientName: "",
        ClientCode: "",
        CustomerIdentification: "",
        CompanyCode: "",
        Comments: "",
        ServiceRequestTypeId: "",
        ProductId: "",
        InitiatedBy: 0,
        ContactCode: "",
        DeviceTypes: [],
        paymentDate: null
      },
      objRules: {
        serviceTypeList: [],
        direccionsList: [],
        departmentList: this.departmentListfiltered,
        departmentselected: null,

        descriptionRules: ""
      },
      rules: {
        descripcionRule: [
          {
            required: true,
            message: "Favor insertar una descripción",
            trigger: "blur"
          },
          {
            min: 3,
            message: "Descripción debe tener minimo 3 caracteres",
            trigger: "blur"
          }
        ],
        employeeId: [
          {
            required: true,
            message: "Seleccione un Responsable",
            trigger: "blur"
          }
        ],
        "serviceTypeList.Id": [
          {
            required: true,
            message: "Inserta una tipo de solicitud",
            trigger: "blur"
          }
        ]
      },
      comment: ""
    };
  },

  mounted() {
    this.getDirectionsById();
    this.getDepartments();
    this.GetProductsByCompany();
    //  this.getServicesTypes();
  },
  computed: {
    departmentListfiltered() {
      let newdepartmentList;
      //console.log("direccionsList: ",this.objRules.direccionsList)
      newdepartmentList = this.departmentList.filter(
        (dl) => dl.Direccion.Id === this.objRules.direccionsList.ID
      );
      //console.log("newdepartmentList: ",newdepartmentList)
      return newdepartmentList;
    },
    serviceTypeFiltered() {
      let serviceType;
      //.log("serviceTypeFiltered: ",this.objRules.serviceTypeList)
      if (
        this.objRules.direccionsList.ID === 41 ||
        this.objRules.direccionsList.ID === 46 ||
        this.objRules.direccionsList.ID === 28
      ) {
        serviceType = this.objRules.serviceTypeList.filter(
          (srt) => srt.DeparmentId === this.objRules.departmentselected
        );
      } else {
        serviceType = this.objRules.serviceTypeList;
      }
      return serviceType;
    }
  },
  methods: {
    opening() {},
    handleClosed(done) {
      this.$refs.formName.resetFields();
      this.closeFormSupport();
      // this.model = {
      //   descriptionRules: ""
      // };
      done();
    },
    submitUpload() {
      this.$refs.uploadFile.submit();
    },
    handleChangeProduct() {
      this.serviceRequestTypeSelectdID = this.objRules.serviceTypeList.Id;
      this.getServicesTypes(this.objRules.direccionsList.ID);
    },
    async handleChangeDirections() {
      //console.log("GerenciaId: ", this.objRules.direccionsList.ID, "\n ResquestObject: ", this.ResquestObject)
      await this.GetEmployeeData();
      await this.getServicesTypes(this.objRules.direccionsList.ID);
      if (this.objRules.direccionsList.ID != 44)
        document.getElementById("payDate").setAttribute("hidden", "hidden");
    },
    handleChangeDepartment(dep) {
      dep;
      //console.log("Department: ", dep)
    },
    showHideInput() {
      //console.log("showHideInput Tipo de solicitud Id: ", this.objRules.serviceTypeList.Id)
      if (this.objRules.direccionsList.ID == 44) {
        switch (this.objRules.serviceTypeList.Id) {
          case 36:
          case 37:
          case 38:
          case 42:
            document.getElementById("payDate").removeAttribute("hidden");
            break;
          default:
            document.getElementById("payDate").setAttribute("hidden", "hidden");
            break;
        }
      }
    },
    GetProductsByCompany() {
      //  this.productList = [];
      this.$http
        .get("/api/products/GetProductsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((resp) => {
          // this.productList = resp.data;
          if (resp.data.length > 0) {
            this.productSelected = resp.data[6];
          }
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async getServicesTypes(criterial) {
      await this.$http
        .get("/api/serviceRequestTypes/GetServiceByCompany", {
          params: {
            direccionID: criterial != undefined ? criterial : 0
          }
        })
        .then((resp) => {
          //console.log("serviceTypeList: ", resp.data);
          this.objRules.serviceTypeList = resp.data.filter(
            (f) => f.IsInternal !== null && f.IsInternal
          );
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          if (this.ResquestObject.ResquestTypeId != 0) {
            //this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId
          }
        });
    },
    getDirectionsById() {
      this.$http
        .get("/api/Directions/GetDirecctionByCompany", {
          params: {
            companyID: this.currentCompany
          }
        })
        .then((resp) => {
          this.objRules.direccionsList = resp.data;

          if (resp.data.length > 0) {
            this.dirSelected = resp.data;
          }
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async getDepartments() {
      const params = {
        params: {
          companyId: this.currentCompany,
          isEne: true
        }
      };
      this.$http
        .get("/api/deparments/all2", params)
        .then((resp) => {
          //console.log("Response: " , resp)
          this.departmentList = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async GetEmployeeData() {
      await this.$http
        .get("/api/Employees/", {
          params: {
            userId: this.currentUser.UserID
          }
        })
        .then((resp) => {
          this.Supervisor = resp.data.SuperVisorID;
        });
    },
    async postServicesTypes() {
      //await this.submitUpload();
      await this.$refs["formName"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.disabledButton = true;
          const { CompanySelected, EmployeeId } = this.currentUser;
          const params = {
            Descripcion: this.comment,
            Tipo: this.objRules.serviceTypeList.Id,
            Responsable: 0,
            Status: 0,
            Supervisor: this.Supervisor,
            Valoracion: 0,
            Company: CompanySelected,
            UserCreator: EmployeeId,
            Attachment: null,
            DescriptionShort: this.objRules.descripcionRule,
            PaymentDate: this.model.paymentDate,
            DirectionsTI: this.ChangesDirectionsIT,
            DirecctionID: this.objRules.direccionsList.ID,
            DepartmentId: this.objRules.departmentselected
            // UploadedFiles: this.fileListUploadFiles.Url
          };
          const url = "/api/InternalServiceRequest/Add";
          await this.$http
            .post(url, params)
            .then(async (resp) => {
              if (resp.data.Message != "") {
                this.$message({
                  type: "info alert",
                  message: resp.data.Message
                });
              }
              if (resp.data) {
                this.filesUploadDates = resp.data;
                // console.log(this.fileListUploadFiles);
                await this.fileListUploadFiles.forEach(async (listFiles) => {
                  var url =
                    "/api/InternalServiceRequest/uploadedFilesResquest/";
                  var params = {
                    UploadedFiles: listFiles.url,
                    internInternalRequestId: this.filesUploadDates.Id
                  };
                  await this.$http
                    .post(url, params)
                    .then((resp) => {
                      //console.log("commente2: ", resp.data);
                      if (resp.data) {
                        this.$message({
                          type: "success",
                          message: "Solicud Creada exitosamente!"
                        });
                        this.$refs.uploadFile.clearFiles();
                        this.filesUpload = 0;
                        this.fileListUploadFiles = [];
                      } else {
                        this.$message.error("Error al agregar Archivo");
                      }
                    })
                    .catch((error) => {
                      //console.log("commente2 catch: ", error)
                      this.$message.error("Error al agregar Archivo", error);
                    });
                });

                this.handleClosed();
                this.$message.success("Solicitud creada!");
                this.$store.commit("SET_UPDATE_INTERNAL_REQUESTS", true);
              } else {
                this.$message.error(" Error al crear solicitud");
              }
            })
            .catch((error) => {
              this.handleClosed();
              this.$message.error(error + " Error al crear solicitud");
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
              this.disabledButton = false;
              this.closeFormSupport();
            });
        } else {
          this.$message.error("Complete el formulario correctamente");
          this.loading = false;
          this.disabledButton = false;
          return false;
        }
      });
    },
    handleUploadOnSuccess(response) {
      const items_count = response.length;
      for (var index = 0; index < items_count; index++) {
        if (items_count > 0) {
          this.fileListUploadFiles.push({
            name: response[index].Name,
            url: response[index].Url
          });
        }
      }
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },
    closeFormSupport() {
      this.disabledButton = false;
      this.drawer = false;
      this.objRules.serviceTypeList.Id = "";
      this.productList.Id = "";
      this.objRules.direccionsList.ID = "";
      this.new_request = {};
      this.comment = "";
      this.productSelectedID = 0;
      this.serviceRequestTypeSelectdID = 0;
      this.Email = "";
      this.FullName = "";
      this.objRules.descriptionRules = "";
      this.handleClosed();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${files.length + fileList.length}`
      );
    },
    handleDelete(index) {
      this.model.DeviceTypes.splice(index, 1);
    }
    /*
    whenOpened(){
      if(this.ResquestObject.DirectionId === 41 && this.ResquestObject.DepartmentId === 47 && this.ResquestObject.ResquestTypeId === 276)
      console.log("hola")
      this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId;
    }*/
  },
  watch: {
    async drawer(val) {
      //console.log(val);
      //console.log("ResquestObject: ",this.ResquestObject)
      if (
        val === true &&
        (this.ResquestObject.DirectionId != 0 ||
          this.ResquestObject.ResquestTypeId != 0) &&
        this.ResquestObject.DirectionId === 28
      ) {
        this.selectionsDisable = true;
        this.objRules.direccionsList.ID = this.ResquestObject.DirectionId;
        this.objRules.serviceTypeList.Id = 224;
        await this.getServicesTypes(this.objRules.direccionsList.ID);
        //await this.handleChangeDirections()
        //console.log("serviceTypeList: ", this.objRules.serviceTypeList)
        if (this.objRules.serviceTypeList.length > 0) {
          //console.log ("y entonces?")
          this.objRules.serviceTypeList.Id = 224;
        }

        //this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId
        //this.showHideInput()
        /*
        const promiseSettingDirection = new Promise((resolve, reject) => {
          resolve(this.objRules.direccionsList.ID = this.ResquestObject.DirectionId);
          this.handleChangeDirections()
        });
        promiseSettingDirection.then(() => {
          this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId
        })
        */
      } else if (
        (val === true &&
          (this.ResquestObject.DirectionId != 0 ||
            this.ResquestObject.ResquestTypeId != 0) &&
          this.ResquestObject.DirectionId === 41) ||
        this.ResquestObject.DirectionId === 46 || //Administracion/RRHH/Finanzas
        this.ResquestObject.DirectionId === 28 //CEO
      ) {
        this.selectionsDisable = false;
        this.objRules.direccionsList.ID = this.ResquestObject.DirectionId;

        await this.getServicesTypes(this.objRules.direccionsList.ID);
        this.objRules.departmentselected = this.ResquestObject.DepartmentId;
        //this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId;
        //this.$refs.serviceTypeFilter.focus();
        if (this.serviceTypeFiltered.length > 0) {
          //console.log ("y entonces? ", this.ResquestObject.ResquestTypeId)
          this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId;
        }
      }
    }
  }
};
</script>
